export default {"LocationContainer":"LocationContainer-module__LocationContainer__cCZBW"};